module.exports = __webpack_public_path__ + "static/media/sort-selection-banner.fce4cbf3.png";